import React from "react"

import Images from "./images"
import Sources from "./sources"
import Properties from "./properties"
import ProsAndCons from "./pros-and-cons"
import { Wrapper, Category, Title, ImagesAndSources, Left, Right, OtherDetails, Hr } from "./styles"

const ProductReview = ({ article, element }) => {
  const { reviewProducts } = article
  const product = reviewProducts.find(({ id }) => id === element.productId)

  if (!product) {
    return null
  }

  const { anchor, category, selectedProperties, selectedSources, selectedImages, pros, cons } =
    element
  const { title, company, images, properties, sources } = product

  const filteredImages = images?.filter((image) => selectedImages?.includes(image.id) || false)
  const filteredSources = sources?.filter((source) => selectedSources?.includes(source.id) || false)
  const filteredProperties = properties?.filter(
    (property) => selectedProperties?.includes(property.id) || false,
  )

  const formatCompany = (c) => (!c || c.trim().length === 0 ? "" : `by ${c}`)

  return (
    <>
      <Wrapper id={`mbg-${anchor}`}>
        <Hr />
        <ImagesAndSources>
          <Left>
            <Images images={filteredImages} />
          </Left>
          <Right>
            <Sources sources={filteredSources} product={product} />
            <Title>
              {title} {formatCompany(company)}
            </Title>
            <Category>{category}</Category>
          </Right>
        </ImagesAndSources>
        <OtherDetails>
          <Properties properties={filteredProperties} />
        </OtherDetails>
      </Wrapper>
      <ProsAndCons pros={pros} cons={cons} />
    </>
  )
}

export default ProductReview
